import Ribbon from 'antd/lib/badge/Ribbon';
import { getSystemLabel } from '../../../utils/systemLabelResolver';

import './TagType.scss';

export type TagProp = {
  type: 'Student' | 'Staff' | 'Alumni' | 'Parent' | 'Faculty';
};
export const TagType = ({ type }: TagProp) => {
  const label = getSystemLabel(`buddyTypes.${type.toUpperCase()}`) ?? type;

  const colorMap: Record<TagProp['type'], string> = {
    Student: '#0DA060',
    Staff: 'purple',
    Alumni: 'blue',
    Parent: 'orange',
    Faculty: 'orange',
  };

  const tagColor = colorMap[type] || 'gray';

  return (
    <Ribbon
      className={`tagType ${type === 'Student' ? 'tagTypeMobile' : 'userRoleBadgeMobile'}`}
      text={label}
      color={tagColor}
    />
  );
};
